import type { AggregatedQto } from "../../types";
import type { OstCondition } from "./types";

/**
 * Stable identifier for one OST condition row, derived directly from the OST file:
 *   - `uid` is `BidCondition.UID`, the file-internal int that all FKs (`BidAreaCondition`,
 *     `BidTakeoff`) point at — guaranteed unique within a file across all `<Bid>` elements,
 *     and stable across re-exports of the same OST job.
 *   - `slotIdx` (1/2/3) disambiguates the up-to-three rows a single condition can expand
 *     into when more than one of its UOM/Quantity slots carries a non-zero quantity.
 *
 * The `ost-` prefix keeps these distinguishable from Togal classification UUIDs and ATO
 * takeoff type ids in line item notes, and ensures the value can never be misread as a
 * UUID by `qtoIdFromLineItemNotes`.
 */
function ostQtoId(condition: OstCondition): string {
  return `ost-${condition.uid}-${condition.slotIdx}`;
}

export function ostConditionsToAggregatedQto(conditions: OstCondition[]): AggregatedQto[] {
  return conditions.map(
    (c): AggregatedQto => ({
      qtoId: ostQtoId(c),
      qtoName: c.name,
      qtoType: "OST",
      quantity: c.quantity,
      uom: c.uom ?? "",
      qtoCustomId: String(c.order),
      ediphiProductId: c.product ?? null,
    })
  );
}
